import { Map as YMap, Placemark, ZoomControl } from '@pbe/react-yandex-maps';

import { cn } from '@/utilities/cn';
import { normalizeCoords } from '@/utilities/normalizeCoords';

export function Map({
  coords,
  coordsList,
  zoom,
  className,
}: {
  coords: string | number[] | null;
  coordsList?: { coords: string; balloonContent?: string }[];
  zoom?: number;
  className?: string;
}) {
  if (!coords) {
    return null;
  }

  const normalized = normalizeCoords(coords);

  const state = {
    zoom: zoom ? zoom : 14,
    center: normalized,
  };

  return (
    <YMap
      className={cn('corners h-[660px] w-full overflow-hidden', className)}
      state={state}
      instanceRef={(ref) => {
        if (ref) ref.behaviors.disable('scrollZoom');
      }}
    >
      {coordsList ? (
        coordsList.map((i) => {
          return (
            <Placemark
              geometry={normalizeCoords(i.coords)}
              options={{
                iconLayout: 'default#image',
                iconImageHref: '/icons/map-pin.svg',
                iconImageSize: [48, 51],
                iconImageOffset: [-24, -51],
              }}
              modules={['geoObject.addon.balloon']}
              properties={{
                balloonContent: i.balloonContent,
              }}
              key={i.coords}
            />
          );
        })
      ) : (
        <Placemark
          geometry={normalized}
          options={{
            iconLayout: 'default#image',
            iconImageHref: '/icons/map-pin.svg',
            iconImageSize: [48, 51],
            iconImageOffset: [-24, -51],
          }}
        />
      )}

      <ZoomControl options={{ position: { right: 15, top: 200 } }} />
    </YMap>
  );
}
